import { render, staticRenderFns } from "./preview-wrapper.vue?vue&type=template&id=52ca7dba&scoped=true&"
import script from "./preview-wrapper.vue?vue&type=script&lang=js&"
export * from "./preview-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./preview-wrapper.vue?vue&type=style&index=0&id=52ca7dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca7dba",
  null
  
)

export default component.exports